import { Action } from '@ngrx/store';
import { Step } from '../components/cmx-stepper/cmx-stepper.component';

/*
 * Actions for the stepper.
 * For the code which carries out these actions, see the reducer at
 * src/app/vanilla/modules/order-builder/reducers/stepper/stepper.reducer.ts
 */

export const UPDATE_STEPS = 'UPDATE_STEPS';
export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
export const DISABLE_NAVIGATION = 'DISABLE NAVIGATION';

export class SetActiveStep implements Action {
  readonly type = SET_ACTIVE_STEP;
  constructor(public payload: number) {}
}

export class UpdateStepsAction implements Action {
  readonly type = UPDATE_STEPS;
  constructor(public payload: Step[]) {}
}

export class DisableNavigation implements Action {
  readonly type = DISABLE_NAVIGATION;
  constructor(public payload: boolean) {}
}

export type StepperActions = UpdateStepsAction | SetActiveStep | DisableNavigation;
